/* 🤖 this file was generated by svg-to-ts */
export const matIconSwapHoriz: {
  name: 'swap-horiz';
  data: string;
} = {
  name: 'swap-horiz',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/></svg>`
};
